module.exports = __webpack_public_path__ + "static/media/venture.02f9d782.png";